import React from 'react';
import { PropTypes } from 'prop-types';
import { compose, pure } from 'recompose';
import styled from 'styled-components';

const enhance = compose(pure);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;
  gap: 2px;
  height: 62px;
`;

const LabelText = styled.div`
  height: 24px;

  /* 16px/regular

Shipper App Default
*/
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  /* grey / 800 */

  color: #3b4f63;
`;
const SubLabelText = styled.div`
  height: 16px;

  /* 14px/regular */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  /* identical to box height, or 114% */

  /* grey / 700 */

  color: #54708c;
`;

const AddressSelector = ({
  activeRef,
  t,
  className,
  address,
  handleClick,
  disabled,
  style,
}) => (
  <button
    type="button"
    className={className}
    onClick={handleClick}
    ref={activeRef}
    disabled={disabled}
    style={style}
    data-e2e="address-selector"
  >
    <Container>
      <LabelText>
        {address.company_name} <>{!!address.label && <> - {address.label}</>}</>
      </LabelText>
      <SubLabelText>
        {address.address_line}, {address.zipcode}.
        {!!address.contact_name || !!address.contact_phone ? (
          <>
            {} {address.contact_name} {address.contact_phone}
          </>
        ) : (
          <>
            {} {t('no_contact')}
          </>
        )}
      </SubLabelText>
    </Container>
  </button>
);

AddressSelector.propTypes = {
  activeRef: PropTypes.func,
  className: PropTypes.string,
  t: PropTypes.func,
  address: PropTypes.shape({}),
  handleClick: PropTypes.func,
  style: PropTypes.object,
};

AddressSelector.defaultProps = {
  className: '',
  t: (k) => k,
  address: {},
  handleClick: () => {},
  activeRef: () => {},
};

export default enhance(AddressSelector);
